module.exports = __webpack_public_path__ + "static/media/letsGo.d4fc30f0.svg";